export enum SortOrder {
  DSC = 'desc',
  ASC = 'asc',
}

export enum SortOrderUp {
  DSC = 'DESC',
  ASC = 'ASC',
}
